import {
  Directive,
  ElementRef,
  Renderer2,
  OnInit,
  OnDestroy,
  NgZone
} from '@angular/core';

@Directive({
    selector: '[appStickyFooter]',
    standalone: false
})
export class StickyFooterDirective implements OnInit, OnDestroy {
  private viewportResizeHandler: any;
  private resizeTimeout: any;
  private lastBottomOffset = 0;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private zone: NgZone
  ) {}

  ngOnInit() {
    if ('visualViewport' in window) {
      this.zone.runOutsideAngular(() => {
        this.viewportResizeHandler = () => {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => {
            const footer = this.el.nativeElement;
            const viewportHeight = window.visualViewport!.height;
            const layoutHeight = window.innerHeight;
            const keyboardHeight = layoutHeight - viewportHeight;

            if (keyboardHeight > 100) {
              if (this.lastBottomOffset !== keyboardHeight) {
                this.renderer.setStyle(footer, 'bottom', `${keyboardHeight}px`);
                this.lastBottomOffset = keyboardHeight;
              }
            } else {
              if (this.lastBottomOffset !== 0) {
                this.renderer.setStyle(footer, 'bottom', `0`);
                this.lastBottomOffset = 0;
              }
            }
          }, 100); 
        };

        window.visualViewport.addEventListener('resize', this.viewportResizeHandler);
      });
    }
  }

  ngOnDestroy() {
    if (this.viewportResizeHandler && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.viewportResizeHandler);
    }
  }
}
